export const UTM_STORAGE_KEY = "ouster_utm_params";
export const UTM_PARAMETERS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function getStoredUTMParams(): Record<string, string> {
  if (typeof window === "undefined") {
    return {};
  }

  const stored = localStorage.getItem(UTM_STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
}
